import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById('hero-section');
      const pricingSection = document.getElementById('pricing');
      if (!heroSection || !pricingSection) return;
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      const pricingTop = pricingSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      if (heroBottom < 0 && pricingTop > windowHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-207">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-bg-dark/80 backdrop-blur-md border-t border-border-light p-4 shadow-[0_-10px_30px_rgba(0,0,0,0.5)]" data-id="element-208">
          <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-209">
            <div className="text-center sm:text-left" data-id="element-210">
              <p className="text-text-main font-bold text-sm sm:text-lg" data-id="element-211">
                BUNDLE ELITE
              </p>
              <p className="text-secondary font-black text-lg sm:text-xl" data-id="element-212">
                €67
              </p>
            </div>
            <a href="#pricing" className="btn-primary-pulse bg-cta-green text-white font-black px-6 sm:px-8 py-3 rounded-xl hover:bg-cta-green-hover transition-colors shadow-[0_0_15px_rgba(16,185,129,0.3)] w-full sm:w-auto text-center text-sm sm:text-base border border-white/10" data-id="element-213">
              🚀 SÌ! VOGLIO RECUPERARE IL MIO TEMPO
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}